import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { ReportAdverseMedia } from 'dashboard/models/report/adverse-media';
import { ReportSnapshotAdverseMedia } from 'dashboard/models/report-snapshot';

interface AdverseMediaProps {
  report: ReportAdverseMedia | ReportSnapshotAdverseMedia;
  isRedacted: boolean;
}

export const AdverseMedia = ({ report, isRedacted }: AdverseMediaProps) => {
  const {
    'name-first': nameFirst,
    'name-middle': nameMiddle,
    'name-last': nameLast,
    term,
    birthdate,
    'country-code': countryCode,
  } = report.attributes;

  return (
    <AttributeGrid>
      {nameFirst && (
        <AttributeItem
          title='First Name'
          value={nameFirst}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__name-first'
        />
      )}
      {nameMiddle && (
        <AttributeItem
          title='Middle Name'
          value={nameMiddle}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__name-middle'
        />
      )}
      {nameLast && (
        <AttributeItem
          title='Last Name'
          value={nameLast}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__name-last'
        />
      )}
      {!nameFirst && !nameMiddle && !nameLast && term && (
        <AttributeItem
          title='Search Term'
          value={term}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__term'
        />
      )}
      {birthdate && (
        <AttributeItem
          title='Birthdate'
          value={formatDate(birthdate)}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__birthdate'
        />
      )}
      {countryCode && (
        <AttributeItem
          title='Country'
          value={countryCode}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-adverse-media__country-code'
        />
      )}
    </AttributeGrid>
  );
};
